var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-alert"},[_c('VuetifyAlert',_vm._b({on:{"onDismissible":_vm.handleDismissible,"onClickActionButton":_vm.handleClickActionButton}},'VuetifyAlert',_vm.appAlert,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }